module.exports = require("vtk.js/Sources/Filters/General/PaintFilter");